import { render } from "./dropzone.vue?vue&type=template&id=c2fd81ae"
import script from "./dropzone.vue?vue&type=script&lang=js"
export * from "./dropzone.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/submission_form/dropzone.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c2fd81ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c2fd81ae', __exports__)) {
    api.reload('c2fd81ae', __exports__)
  }
  
  module.hot.accept("./dropzone.vue?vue&type=template&id=c2fd81ae", () => {
    api.rerender('c2fd81ae', render)
  })

}


export default __exports__